const API_GATEWAY_URL = (process.env.VUE_APP_API_GATEWAY_URL || '').replace(/\/$/, '')
const API_GATEWAY_TOKEN = process.env.VUE_APP_API_GATEWAY_TOKEN || ''
const LLM_API_URL = /^https?:\/\//i.test(API_GATEWAY_URL)
  ? `${API_GATEWAY_URL}/v1/messages`
  : ''
const LLM_MODEL = process.env.VUE_APP_LLM_MODEL || 'deepseek-v4-pro'
const MAX_TOKENS = Number(process.env.VUE_APP_LLM_MAX_TOKENS || 4096)

const SYSTEM_PROMPT = `你是古贤水利智能助手，服务于黄河古贤水利枢纽工程。
你可以根据用户意图调用工具打开对应业务面板；闲聊或常识性回复不需要调用工具。

工具选择规则：
- 具体监测数据（水位、降雨、水质、入库出库流量等）：open_monitoring 或 open_left_board。
- 供水规模、方案对比：open_water_supply。
- 来水、需水、模型、预测：open_right_board 或 open_scheme_compare。
- 调度、预演、洪水演进：open_scheduling、open_custom_dispatch 或 open_flood_simulation。
- 施工安全：open_safety_qa。
- 工程规范、案例、设计知识：open_knowledge_qa。
- 应急、预案、风险：open_emergency 或 open_emergency_plan。
- 运维、通知、设施定位、水库详情：打开对应业务面板。

问数演示要求：
- 用户询问某站点、区域或工程对象的水位、流量、降雨、水质、供水、需水、缺额等数据时，必须在回复中给出具体数值、单位、状态和简短研判。
- 如果上下文没有真实数据，直接生成合理的演示模拟数据，不要说"暂无数据"。
- 回复先给结论，再说明已打开的面板。

语音播报要求（重要）：
- 你的回复会经过语音合成播报，请只输出关键性信息，控制在 80 字以内。
- 数字和单位可以直接写符号（如 1268.5 m3/s、0.32 亿m³、529 km²、120 MW），语音引擎会自动读成"立方米每秒""亿立方米""平方千米""兆瓦"。
- 不要罗列大量同步指标，只报用户最关心的 1-2 个核心数据。
- 不要输出"来源""时间戳""数据源说明"等元信息。

每次工具调用后，只用 1 句简洁中文告诉用户已经打开了什么，不要啰嗦。`

const TOOLS = [
  { name: 'open_monitoring', description: '综合监控大屏：入库出库流量、水库水位、行业用水分配、水源构成等实时图表', input_schema: { type: 'object', properties: {}, required: [] } },
  { name: 'open_water_supply', description: '供水规模对比表：多个方案的供水指标、投资、经济性等对比数据', input_schema: { type: 'object', properties: {}, required: [] } },
  { name: 'open_left_board', description: '左侧看板：供水范围覆盖面积、水量配置方案、降雨预警、水质污染监测', input_schema: { type: 'object', properties: {}, required: [] } },
  { name: 'open_right_board', description: '右侧看板：专业模型、区域需水预测、来水预测方案、调度预演方案', input_schema: { type: 'object', properties: {}, required: [] } },
  { name: 'open_scheme_compare', description: '来水预测方案：多方案预测对比（实测、P50/P90/P10方案）、流量过程线、精度评定指标（QR/DC/NSE/MAE/RMSE/PPTS）、洪峰流量与峰现时间', input_schema: { type: 'object', properties: {}, required: [] } },
  { name: 'open_flow_chart', description: '流量过程线：实测流量与模型预测流量对比图表', input_schema: { type: 'object', properties: {}, required: [] } },
  { name: 'open_custom_dispatch', description: '自定义调度参数：固定下泄调度和补偿调度，输入参数后开始预演', input_schema: { type: 'object', properties: {}, required: [] } },
  { name: 'open_scheduling', description: '运行调度任务管理：新增、编辑、删除、启停调度任务，导出 CSV', input_schema: { type: 'object', properties: {}, required: [] } },
  { name: 'open_flood_simulation', description: '洪水预演场景构建：选择防护目标、节点和下泄方案，进行淹没分析仿真', input_schema: { type: 'object', properties: {}, required: [] } },
  { name: 'open_construction', description: '智能建造面板：BIM 构件状态、设备运行、AI 风险预警', input_schema: { type: 'object', properties: {}, required: [] } },
  { name: 'open_project', description: '工程管理面板：总体进度、关键里程碑、施工单位、设备到货、质量安全巡检', input_schema: { type: 'object', properties: {}, required: [] } },
  { name: 'open_emergency', description: '应急管理面板：物资储备、应急队伍、演练记录、风险研判', input_schema: { type: 'object', properties: {}, required: [] } },
  { name: 'open_maintenance', description: '运维管理面板：设备运行状态、巡检记录、维护工单、设备寿命和值班安排', input_schema: { type: 'object', properties: {}, required: [] } },
  { name: 'open_notice', description: '通知公告管理：新增、置顶、标记已读、删除公告', input_schema: { type: 'object', properties: {}, required: [] } },
  { name: 'open_reservoir_info', description: '水库详细信息：总库容、调节库容、装机容量、发电量等参数', input_schema: { type: 'object', properties: {}, required: [] } },
  { name: 'open_facility_control', description: '设施定位控制：定位水库、泵站、调蓄池、灌溉区并飞行到对应位置', input_schema: { type: 'object', properties: {}, required: [] } },
  { name: 'open_knowledge_qa', description: '工程设计知识问答：大坝、导流、防洪、混凝土、泄洪、边坡、防渗、生态流量等专业领域', input_schema: { type: 'object', properties: {}, required: [] } },
  { name: 'open_safety_qa', description: '施工安全知识问答', input_schema: { type: 'object', properties: {}, required: [] } },
  { name: 'open_scheduling_qa', description: '运行调度知识问答', input_schema: { type: 'object', properties: {}, required: [] } },
  { name: 'open_warning', description: '打开智能预警监测，查看降雨预警和水质污染实时动态数据', input_schema: { type: 'object', properties: {}, required: [] } },
  { name: 'open_supply_demand', description: '打开供需平衡分析，查看可供水量与需水量对比、分区平衡状态和缺额预警', input_schema: { type: 'object', properties: {}, required: [] } },
  { name: 'open_emergency_plan', description: '打开应急预案管理，查看并激活防汛、设备故障、管线泄漏等应急预案', input_schema: { type: 'object', properties: {}, required: [] } },
]

export const ACTION_PANEL_MAP = {
  open_monitoring: 'monitoring',
  open_water_supply: 'waterSupply',
  open_left_board: 'leftBoard',
  open_right_board: 'rightBoard',
  open_scheme_compare: 'mulSchemes',
  open_flow_chart: 'monitoring',
  open_custom_dispatch: 'custom',
  open_scheduling: 'scheduling',
  open_flood_simulation: 'floodSim',
  open_construction: 'construction',
  open_project: 'project',
  open_emergency: 'emergency',
  open_maintenance: 'maintenance',
  open_notice: 'notice',
  open_reservoir_info: 'reservoir',
  open_facility_control: 'reservoirCtrl',
  open_knowledge_qa: 'knowledgeQA',
  open_safety_qa: 'safetyQA',
  open_scheduling_qa: 'schedulingQA',
  open_warning: 'monitoring',
  open_supply_demand: 'supplyDemand',
  open_emergency_plan: 'emergency',
}

function assertConfigured() {
  if (!LLM_API_URL || !API_GATEWAY_TOKEN) {
    throw new Error('缺少 VUE_APP_API_GATEWAY_URL 或 VUE_APP_API_GATEWAY_TOKEN。')
  }
}

function buildMessages(systemMessages, context, userText) {
  const messages = []
  if (context && context.length > 0) messages.push(...context)
  messages.push({ role: 'user', content: userText })
  if (systemMessages && systemMessages.length > 0) messages.push(...systemMessages)
  return messages
}

async function callAPI(messages, options = {}) {
  assertConfigured()

  const response = await fetch(LLM_API_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${API_GATEWAY_TOKEN}`,
    },
    body: JSON.stringify({
      model: LLM_MODEL,
      max_tokens: options.maxTokens || MAX_TOKENS,
      system: options.system || SYSTEM_PROMPT,
      messages,
      tools: options.tools === undefined ? TOOLS : options.tools,
    }),
  })

  if (!response.ok) {
    const errText = await response.text()
    throw new Error(`API ${response.status}: ${errText.slice(0, 300)}`)
  }

  return response.json()
}

function parseResponse(data) {
  let text = ''
  const actions = []

  if (data.content && Array.isArray(data.content)) {
    for (const block of data.content) {
      if (block.type === 'text') {
        text += block.text
      } else if (block.type === 'tool_use') {
        const panelKey = ACTION_PANEL_MAP[block.name]
        if (panelKey) actions.push(panelKey)
      }
    }
  }

  return { text: text || '好的。', actions }
}

export function askKnowledge(question) {
  const system = `你是黄河古贤水利枢纽工程的资深水利工程师专家。
请围绕大坝稳定、施工导流、防洪调度、混凝土温控防裂、泄洪消能、边坡稳定、防渗设计、生态流量和施工组织等方向，提供专业、准确、结构清晰的回答。
如涉及规范，请尽量给出规范名称或条文依据；每次回答控制在 200-400 字。`

  return callAPI([{ role: 'user', content: question }], {
    maxTokens: 4096,
    system,
    tools: [],
  }).then(data => {
    return data.content?.map(block => block.type === 'text' ? block.text : '').join('') || '抱歉，暂时无法回答。'
  })
}

export class LLMService {
  constructor() {
    this._systemMessages = []
  }

  async ask(userText, conversationContext = null) {
    const initialMessages = buildMessages(this._systemMessages, conversationContext, userText)
    const data = await callAPI(initialMessages)

    const toolUses = []
    if (data.stop_reason === 'tool_use' && data.content) {
      for (const block of data.content) {
        if (block.type === 'tool_use') toolUses.push(block)
      }
    }

    if (toolUses.length === 0) {
      const result = parseResponse(data)
      this._storeContext(conversationContext, userText, data.content)
      return result
    }

    const firstResult = parseResponse(data)
    const followUpMessages = [...initialMessages]
    followUpMessages.push({ role: 'assistant', content: data.content })
    const toolResults = toolUses.map(tu => ({ type: 'tool_result', tool_use_id: tu.id, content: 'success' }))
    followUpMessages.push({ role: 'user', content: toolResults })

    const finalData = await callAPI(followUpMessages)
    const finalResult = parseResponse(finalData)
    const combinedText = (firstResult.text + ' ' + finalResult.text).trim()
    const combinedActions = [...new Set([...firstResult.actions, ...finalResult.actions])]

    this._storeContext(conversationContext, userText, data.content, toolResults, finalData.content)
    return { text: combinedText, actions: combinedActions }
  }

  _storeContext(context, userText, assistantContent, toolResults = null, finalContent = null) {
    if (!context) return
    const lastUserIdx = context.length > 0 && context[context.length - 1].role === 'user' ? context.length - 1 : context.length

    if (toolResults && finalContent) {
      context[lastUserIdx] = { role: 'user', content: userText }
      context.push({ role: 'assistant', content: assistantContent })
      context.push({ role: 'user', content: toolResults })
      context.push({ role: 'assistant', content: finalContent })
    } else {
      if (lastUserIdx < context.length) context[lastUserIdx].content = userText
      context.push({ role: 'assistant', content: assistantContent })
    }

    if (context.length > 30) context.splice(0, context.length - 30)
  }

  resetContext() {
    this._systemMessages = []
  }
}
